import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/mm100/h5/');

export default function Comp({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.listAH5} listAH5`}>
            <div className="listAH5-title">{t('presale.product.listA_ms1')}</div>
            <p className="listAH5-desc">{t(locale === 'kr' ? 'presale.product.listA_ms2_h5' : 'presale.product.listA_ms2')}</p>
            <div className="listAH5-img">
                <EFPic name={['listA1.webp', 'listA1.jpg']} className="fullImgs" alt={t('presale.product.listA_ms1')} />
                <div className="product-width">{t('presale.product.listA_ms3')}</div>
                <div className="product-height">{t('presale.product.listA_ms4')}</div>
            </div>
        </div>
    );
}
